import { formatEventDate, getFullDate, getMainParlayCardDate } from '@draftkings/sportsbook-common-utils';

export function formatDate(dateString: string, isParlayCardComponent: boolean, locale: string): string {
    const date = new Date(dateString);
    const formattedDate = formatEventDate(date, locale);

    // if it's parlay card and isToday, return "TODAY" else return "TODAY" + fromated date
    // if it's parlay card and isTomorrow, return "TOMORROW" else return "TOMORROW" + fromated date if it's not today or tomorrow, return the formatted date
    if (formattedDate.daysAway === 0 || formattedDate.daysAway === 1) {
        return isParlayCardComponent
            ? formattedDate.dayPhrase
            : `${formattedDate.dayPhrase} ${formattedDate.formatterTime}`;
    }

    // if it is a parlay card or is not, and it is not today or tomorrow, return the formatted date
    return isParlayCardComponent ? `${getMainParlayCardDate(date, locale)}` : `${getFullDate(date, locale)}`;
}
